if (!customElements.get('ys-series-floating-cart')) {
  customElements.define('ys-series-floating-cart', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.button = this.querySelector('button[aria-controls]');
      this.panel = this.querySelector('.ys-series-floating-cart__panel');
      this.button.addEventListener('click', () => {
        const collapsed = this.classList.toggle('is-collapsed');
        this.panel.hidden = collapsed;
        this.button.setAttribute('aria-expanded', String(!collapsed));
        this.button.setAttribute('aria-label', collapsed ? 'Expand quick add' : 'Collapse quick add');
        this.querySelector('[data-toggle-label]').textContent = collapsed ? 'Quick add' : '×';
      }, { signal });
      const update = () => { this.hidden = window.scrollY < Number(this.dataset.delay || 0); };
      window.addEventListener('scroll', update, { passive: true, signal });
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
